import moment from 'moment-timezone';
import { TimeZone } from '../constants/AppConstants';

function trainTime (timeStr, format = null) {
    return moment.tz(timeStr, format, TimeZone);
}

const utilMethods = 'min max utc unix months isDate locale invalid duration isMoment weekdays isDuration monthsShort weekdaysMin weekdaysShort normalizeUnits'.split(' ');

function proxyStatic (name) {
    trainTime[name] = moment[name].bind(moment);
}

utilMethods.forEach(proxyStatic);

trainTime.isTrainTime = function istrainTime (datetime) {
    return trainTime.isMoment(datetime) && datetime.tz() === TimeZone;
};

moment.fn.calendarDuration = function(d2) {
    return trainTime.calendarDuration(this, d2);
};

trainTime.calendarDuration = function (d1, d2) {
    return moment.duration(trainTime.calendarDiff(d1, d2));
};

moment.fn.calendarDiff = function (d2) {
    return trainTime.calendarDiff(this, d2);
};

trainTime.calendarDiff = function(d1, d2) {
    // Adapted from moment-precise-range to return a differences object which can be used to construct a moment.duration
    // https://github.com/codebox/moment-precise-range
    /**
     * @license
     * The MIT License (MIT)
     * Copyright (c) 2014 Rob Dawson
     * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
     */
    let m1 = trainTime(d1);
    let m2 = trainTime(d2);
    let sign = 1;

    if (m1.isSame(m2)) {
        return {
            years: 0,
            months: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        };
    }

    if (m1.isBefore(m2)) {
        sign = -1;
        [m1, m2] = [m2, m1];
    }

    let mDiff = m1.month() - m2.month();
    let dDiff = m1.date() - m2.date();
    let hourDiff = m1.hour() - m2.hour();
    let minDiff = m1.minute() - m2.minute();
    let yDiff = m1.year() - m2.year();
    let secDiff = m1.second() - m2.second();

    if (secDiff < 0) {
        secDiff = 60 + secDiff;
        minDiff--;
    }
    if (minDiff < 0) {
        minDiff = 60 + minDiff;
        hourDiff--;
    }
    if (hourDiff < 0) {
        hourDiff = 24 + hourDiff;
        dDiff--;
    }
    if (dDiff < 0) {
        const daysInLastFullMonth = trainTime(m1.year() + '-' + (m1.month() + 1), "YYYY-MM").subtract(1, 'M').daysInMonth();
        if (daysInLastFullMonth < m2.date()) { // 31/01 -> 2/03
            dDiff = daysInLastFullMonth + dDiff + (m2.date() - daysInLastFullMonth);
        } else {
            dDiff = daysInLastFullMonth + dDiff;
        }
        mDiff--;
    }
    if (mDiff < 0) {
        mDiff = 12 + mDiff;
        yDiff--;
    }

    return {
        years: sign * yDiff,
        months: sign * mDiff,
        days: sign * dDiff,
        hours: sign * hourDiff,
        minutes: sign * minDiff,
        seconds: sign * secDiff
    };
};

moment.fn.isSameWeek = function(d2) {
    return trainTime.isSameWeek(this, d2);
};

trainTime.isSameWeek = function(d1, d2) {
    return d1.isoWeek() !== d2.isoWeek();
};

moment.fn.isWeekendDate = function() {
    return trainTime.isWeekendDate(this);
};

trainTime.isWeekendDate = function(date) {
    return (date.isoWeekday() === 6 || date.isoWeekday() === 7);
};

moment.fn.addWorkingDays = function(days) {
    return trainTime.addWorkingDays(this, days);
};

trainTime.addWorkingDays = function(date, days) {
    const startDate = date.clone().startOf('day');
    let weekendDays = 0;

    date.startOf('day').add(days, 'days');

    if (trainTime.isWeekendDate(date)) {
        weekendDays += 2;
    }

    if (trainTime.isSameWeek(startDate, date)) {
        weekendDays += 2 * (date.isoWeek() - startDate.isoWeek());
        if (trainTime.isWeekendDate(startDate)) {
            weekendDays -= startDate.isoWeekday() - 5;
        }
    } else {
        if (trainTime.isWeekendDate(startDate)) {
            weekendDays -= date.isoWeekday() - 6;
        }
    }

    return date.add(weekendDays, 'days');
};

trainTime.ukDate = function(date) {
    return moment(date).format('DD-MM-YYYY');
};

trainTime.ukDateTime = function(date) {
    return moment(date).format('DD-MM-YYYY HH:mm');
};

trainTime.isoDate = function(date) {
    return moment(date).format('YYYY-MM-DD');
};

trainTime.isToday = function(date) {
    // return moment(date).isSame(moment().startOf('day'), 'd');
    return moment(date).isSame(moment(), 'day');
};

trainTime.isTomorrow = function(date) {
    return moment(date).isSame(moment().add(1, 'days').startOf('day'), 'd');
};

trainTime.isInThePast = function (date) {
    const now = moment();
    return now.isAfter(moment(date));
};

export default trainTime;



// WEBPACK FOOTER //
// ./src/lib/TrainTime.js